<template>
  <section class="section">
    <LazyBg :src="bgSrc" />
    <div class="container">
      <h2 class="section-title">AI加速核心能力</h2>
      <p class="section-lead">从训练到部署的全栈AI基础设施优化</p>
      <div class="features-grid">
        <div v-for="f in features" :key="f.title" class="feature-card">
          <div class="feature-icon" v-html="f.icon" />
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/AI_bg2.jpg';
import LazyBg from '@/components/LazyBg.vue';
const features = [
  {
    title: '分布式训练加速',
    desc: '自研分布式训练框架，支持数据并行、模型并行、流水线并行，千卡集群线性加速比达 90% 以上。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>'
  },
  {
    title: '预置环境镜像',
    desc: 'PyTorch、TensorFlow、JAX、DeepSpeed、Megatron 等主流框架预装，开箱即用，5 分钟启动训练任务。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>'
  },
  {
    title: '高速互联网络',
    desc: 'NVLink + InfiniBand 高速互联，节点间通信延迟低于 1μs，满足大模型参数同步的高带宽需求。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>'
  },
  {
    title: '模型推理优化',
    desc: '集成 TensorRT、vLLM、ONNX Runtime 等推理引擎，支持模型量化、剪枝、蒸馏，推理吞吐提升 3-5 倍。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>'
  },
  {
    title: '实验管理与监控',
    desc: '内置实验追踪、超参管理、性能分析工具，支持 TensorBoard、Weights & Biases 集成，可视化管理训练过程。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4"/><path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"/></svg>'
  },
  {
    title: '数据安全隔离',
    desc: '物理隔离的计算环境，数据加密存储与传输，满足金融、医疗等敏感行业的数据安全合规要求。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
  }
];
</script>
<style scoped lang="scss">
.container {
  position: relative;
  z-index: 1;
}

 .section {
  /* bg via LazyBg */
}
</style>